import jwtAxios from '@crema/services/auth/jwt-auth';

const emailSettingsApi = {
  // SMTP Settings
  getEmailSettings: () => {
    return jwtAxios.get('/email-settings');
  },

  updateEmailSettings: (settings) => {
    return jwtAxios.put('/email-settings', settings);
  },

  testSmtpConnection: (settings) => {
    return jwtAxios.post('/email-settings/test', settings);
  },

  // Recipients
  getRecipients: () => {
    return jwtAxios.get('/email-settings/recipients');
  },

  addRecipient: (recipient) => {
    return jwtAxios.post('/email-settings/recipients', recipient);
  },

  updateRecipient: (id, recipient) => {
    return jwtAxios.put(`/email-settings/recipients/${id}`, recipient);
  },

  deleteRecipient: (id) => {
    return jwtAxios.delete(`/email-settings/recipients/${id}`);
  },

  // Test Email
  sendTestEmail: (testData) => {
    return jwtAxios.post('/email-settings/send-test', testData);
  },

  // Scheduler
  getSchedulerStatus: () => {
    return jwtAxios.get('/email-settings/scheduler-status');
  },

  triggerDailyReports: () => {
    return jwtAxios.post('/email-settings/trigger-daily-reports');
  },
};

export default emailSettingsApi;
